<script lang="ts">
  import * as countup from "countup.js";
  import { onMount } from "svelte";
  import { inview } from "svelte-inview";
  export let value: number;

  const { CountUp } = countup;

  var cu: any;
  let el: any;
  let initialValue = value;
  let isInView: boolean = false;

  const randBetween = (min: number, max: number) =>
    Math.floor(Math.random() * (max - min + 1) + min);

  function ele() {
    if (!el) return;

    cu = new CountUp(el, initialValue, {
      startVal: initialValue - 20,
      duration: randBetween(2, 4),
    });
  }

  $: el && ele();
  $: isInView && onInView(cu);
  $: value && updateValue(cu);

  function onInView(cu) {
    if (!cu) return;
    cu.start();
  }

  function updateValue(cu) {
    if (!cu || !isInView) return;
    cu.update(value);
  }
</script>

<div
  bind:this={el}
  use:inview={{ unobserveOnEnter: true }}
  on:enter={(event) => {
    const { inView } = event.detail;
    isInView = inView;
  }}
/>
